export default __webpack_public_path__ + "static/media/Vaspar.b98026d9.jpg";